import * as actionTypes from '../constants/ActionTypes/Dashboard';

export const FetchDeviceInfo = (deviceId, UID) => ({
    type: actionTypes.DASHBOARD_DEVICE_INFO_CALL_INIT,
    deviceId,
    UID
})

export const ResetDeviceInfo = () => ({
    type: actionTypes.RESET_DASHBOARD_DEVICE_INFO_CALL
})

export const FetchOrderHistory = (UID, deviceId = null) => ({
    type: actionTypes.DASHBOARD_ORDER_HISTORY_CALL_INIT,
    UID,
    deviceId
})

export const ResetOrderHistory = () => ({
    type: actionTypes.RESET_DASHBOARD_ORDER_HISTORY_CALL
})

export const DownloadOrderInvoice = (UID, invoiceId, invoiceDate) => ({
    type: actionTypes.DOWNLOAD_ORDER_INVOICE,
    UID,
    invoiceId,
    invoiceDate
})

export const FetchMyAccount = (UID, deviceId = null) => ({
    type: actionTypes.FETCH_MY_ACCOUNT,
    UID,
    deviceId
});

export const ResetFetchMyAccount = () => ({
    type: actionTypes.FETCH_MY_ACCOUNT_RESET
});

export const UpdateShippingAddress = (subscriptionPayload) => ({
    type: actionTypes.UPDATE_SHIPPING_ADDR,
    subscriptionPayload
})

export const ResetUpdateShippingAddress = () => ({
    type: actionTypes.RESET_UPDATE_SHIPPING_ADDR
})


export const ManageUpdateShippingResetState = () => ({
    type: actionTypes.RESET_STATE
})

export const CancelOrder = (uid, deviceId, feedbackSelection, otherReason, personalOrBusinessAccount, role = null, customerCountryCode = null, isBrotherPlusCancellationEnabled = false, BPID = null, isEcoProDelayedCancellation = false) => ({
    type: actionTypes.CANCEL_ORDER,
    uid,
    deviceId,
    feedbackSelection,
    otherReason,
    personalOrBusinessAccount,
    role,
    customerCountryCode,
    isBrotherPlusCancellationEnabled,
    BPID,
    isEcoProDelayedCancellation
});

export const resetCancelOrder = () => ({
    type: actionTypes.RESET_CANCEL_ORDER
})

export const GetCancellationFee = (uid, deviceId) => ({
    type: actionTypes.GET_CANCELLATION_FEES,
    uid,
    deviceId
})
export const storeSelectedFeedback = (selectedFeedback) => ({
    type: actionTypes.STORE_FEEDBACK,
    selectedFeedback
})

export const SwapDevice = (UID, oldDeviceId, newDeviceId) => ({
    type: actionTypes.SWAP_DEVICE,
    UID,
    oldDeviceId,
    newDeviceId
})
export const resetSwapDevice = () => ({
    type: actionTypes.RESET_SWAP
})

export const UpdateSubscriptionPlan = (updatedPlanDetails) => ({
    type: actionTypes.UPDATE_PLAN,
    updatedPlanDetails
})

export const UpdatePlanReset = () => ({
    type: actionTypes.UPDATE_PLAN_RESET
})

export const SignOut = () => ({
    type: "USER_LOGOUT"
})

export const SignUpUserFeedback = (feedbackData, feedbackType) => ({
    type: actionTypes.SIGNUP_USER_FEEDBACK,
    feedbackData,
    feedbackType
})

export const GetUserSubscriptionAccountSummary = (UID) => ({
    type: actionTypes.GET_USER_SUBSCRIPTION_ACCOUNT_SUMMARY,
    UID
})

export const ResetUserSubscriptionAccountSummary = () => ({
    type: actionTypes.GET_USER_SUBSCRIPTION_ACCOUNT_SUMMARY_RESET
})

export const GetCancelSubscriptionStatus = (UID, deviceId) => ({
    type: actionTypes.GET_CANCEL_SUBSCRIPTION_STATUS,
    UID,
    deviceId
})

export const ResetUserFeedback = () => ({
    type: actionTypes.RESET_STATE,
})

export const EnrollmentStatus = (enrollmentStatus) => ({
    type: actionTypes.ENROLLMENT_STATUS_CHECK,
    enrollmentStatus
})

export const EnrollmentStatus_BrotherPlus = (enrollmentStatus) => ({
    type: actionTypes.ENROLLMENT_STATUS_CHECK_BROTHER_PLUS,
    enrollmentStatus
})

export const AsyncEnrollmentRetry = (payloadData) => ({
    type: actionTypes.ASYNC_ENROLLMENT_RETRY_INIT,
    payloadData
})

export const ReactivateSubscription = (role = null, userId = null, deviceId = null) => ({
    type: actionTypes.REACTIVATE_SUBSCRIPTION_INIT,
    role,
    userId,
    deviceId
})

export const ResetCancelSubscriptionResult = () => ({
    type: actionTypes.RESET_CANCEL_SUBSCRIPTION
})

export const ResetSubscriptionReactivationResult = () => ({
    type: actionTypes.RESET_REACTIVATED_SUBSCRIPTION
})

export const ResetCancelOrderAndFeedback = () => ({
    type: actionTypes.RESET_CANCEL_ORDER_AND_FEEDBACK
})

export const GetUserSubscription = (UID, deviceID) => ({
    type: actionTypes.GET_USER_SUBSCRIPTION,
    UID,
    deviceID
})

export const ResetUserSubscription = () => ({
    type: actionTypes.GET_USER_SUBSCRIPTION_RESET
})

export const Upgrade_To_Ecopro_Status = (isUpgradeInitiated) => ({
    type: actionTypes.UPGRADE_TO_ECOPRO_STATUS_CHECK,
    isUpgradeInitiated
})